import api from "@/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { useToast } from "@/composables/toast";


const manyKey = ["users", "many"];

export function useUsers() {
    return useQuery({
        queryKey: manyKey,
        queryFn: async () => api.get("users"),
    });
}

export function useUser() {
    return useQuery({
        queryKey: ["user"],
        queryFn: async () => await api.get("user"),
    });
}

export function useUpdateUser() {
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: async function (data: any) {
            return await api.put(`/user/${data.id}`, data);
        },
        onSuccess: function (data) {
            queryClient.setQueryData(["user"], data);
            toast.add({
                severity: "success",
                summary: "Profile updated",
                detail: "Your profile has been updated successfully",
            });
        },
    });
}
